import React, { useEffect } from 'react';
import { Send } from '@saleshandy/icons';
import AddToSequenceModalDropDown from '../../../../../../../shared/components/add-to-sequence-modal';
import { RequestStatus } from '../../../../../../../shared/enums/request-status';
import { showGeneralErrorNotification } from '../../../../../../../shared/utils/errors';
// eslint-disable-next-line import/no-cycle
import { IProps } from './add-to-sequence-modal-container';
import { ResourceIdentifiers } from '../../../../../../../shared/utils/access-control/enums/resource-identifiers';
import hasResource from '../../../../../../../shared/utils/access-control/has-resource';
import planPermissionError from '../../../../../../../shared/utils/errors/plan-permission-error';
import { isFreePlan } from '../../../../../../../shared/utils/plans';

const AddToSequenceModal: React.FC<IProps> = ({
  show,
  onHide,
  resetStepAndSequence,
  sendGetSequenceList,
  sendGetSequenceStepList,
  getSequenceListRequestStatus,
  getStepListRequestStatus,
  getSequenceListRequestError,
  getStepListRequestError,
  sequenceList,
  stepList,
  addToSequence,
  addToStepRequestStatus,
  sequence,
  isSubscribed,
  currentSequenceId,
}) => {
  useEffect(() => {
    if (sequence && sequence.id) {
      sendGetSequenceStepList(sequence.id);
    } else {
      sendGetSequenceList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => () => {
      resetStepAndSequence();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const sendGetStepRequest = (selectedSequence) => {
    sendGetSequenceStepList(selectedSequence);
  };

  useEffect(() => {
    if (getSequenceListRequestStatus === RequestStatus.Failed) {
      if (getSequenceListRequestError) {
        showGeneralErrorNotification(getSequenceListRequestError.message);
      }
    }
    if (getStepListRequestStatus === RequestStatus.Failed) {
      if (getStepListRequestError) {
        showGeneralErrorNotification(getStepListRequestError.message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSequenceListRequestStatus, getStepListRequestStatus]);

  const onSubmit = (selectedSequenceId, selectedStepId) => {
    if (
      isFreePlan() &&
      !hasResource(ResourceIdentifiers.SEQUENCES_CONTACTS_IMPORT)
    ) {
      const title = 'Please upgrade your plan to start adding prospects';
      const content = [
        'Your account is downgraded to a free plan. Upgrade to paid plan to add prospects and resume email sending.',
      ];

      planPermissionError.showModal(title, content, true);
      return;
    }
    addToSequence(selectedSequenceId, selectedStepId);
    onHide();
  };

  const isFetchingSequenceList =
    getSequenceListRequestStatus === RequestStatus.Pending;
  const isFetchingStepList = getStepListRequestStatus === RequestStatus.Pending;

  const isSubmitRequestPending =
    addToStepRequestStatus === RequestStatus.Pending;
  return (
    <AddToSequenceModalDropDown
      show={show}
      contactSequenceList={sequenceList}
      contactStepList={stepList}
      isFetchingSequenceList={isFetchingSequenceList}
      isFetchingStepList={isFetchingStepList}
      isSubmitRequestPending={isSubmitRequestPending}
      onHide={onHide}
      onSubmit={onSubmit}
      sendGetStepRequest={sendGetStepRequest}
      className="add-sequence-prospect-modal"
      icon={<Send />}
      sequence={sequence}
      showWarning={!isSubscribed}
      submitRequestStatus={addToStepRequestStatus}
      currentSequenceId={currentSequenceId}
    />
  );
};

export default AddToSequenceModal;
